<div [ngClass]="statusClass">
  <span class="status-text">{{ formattedStatus }}</span>: {{ formattedState }}<span *ngIf="statusReason"> / {{ statusReason }}</span>
</div>
